import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ArrAddInput from "../ArrAddInput";
import { updateConfig as _updateConfig, listConfig } from "@/api/configurationlist";
import { cloneDeep, isEqual } from 'lodash';
export default {
  name: "PortalAuthentication",
  props: ["deviceDid", "deviceSn"],
  data: function data() {
    return {
      loading: true,
      DebuggingList: [{
        value: '0',
        label: this.$t('lang.ConfigSetting.not')
      }, {
        value: '1',
        label: this.$t('lang.ConfigSetting.error')
      }, {
        value: '2',
        label: this.$t('lang.ConfigSetting.information')
      }, {
        value: '3',
        label: this.$t('lang.ConfigSetting.debug')
      }],
      data: {},
      WatchData: {}
    };
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler: function handler(newValue, oldValue) {
        this.getConfig();
      }
    }
  },
  components: {
    ArrAddInput: ArrAddInput
  },
  methods: {
    // 获取配置参数
    getConfig: function getConfig() {
      var _this = this;

      this.loading = true;
      listConfig(this.deviceSn, this.deviceDid, [{
        section: "nodogsplash",
        config: "nodogsplash",
        options: [{
          option: "enabled"
        }, {
          option: "weburl"
        }, {
          option: "webrefresh"
        }, {
          option: "redirecturl"
        }, {
          option: "sessiontimeout"
        }, {
          option: "maxclients"
        }, {
          option: "debuglevel"
        }, {
          option: "nowired"
        }],
        lists: [{
          list: 'preauthenticated_users'
        }, {
          list: 'authenticated_users'
        }, {
          list: 'trustedmac'
        }]
      }]).then(function (res) {
        _this.data = _objectSpread(_objectSpread({}, res.data.data.mess[0].s_objects[0].options), res.data.data.mess[0].s_objects[0].lists); //设备复选框值转换成布尔值

        _this.data.enabled = _this.data.enabled == '1' ? true : false;
        _this.data.webrefresh = _this.data.webrefresh == '1' ? true : false;
        _this.data.nowired = _this.data.nowired == '1' ? true : false;
        _this.WatchData = cloneDeep(_this.data);
        _this.loading = false;
      }).catch(function (err) {
        _this.$message({
          message: _this.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    //获取未认证设备
    GetPreauthenticatedUsers: function GetPreauthenticatedUsers(props) {
      this.data.preauthenticated_users = props;
    },
    //获取已认证设备
    GetAuthenticatedUsers: function GetAuthenticatedUsers(props) {
      this.data.authenticated_users = props;
    },
    //获取免认证设备MAC地址
    GetTrustedMac: function GetTrustedMac(props) {
      this.data.trustedmac = props;
    },
    //保存配置
    updateConfig: function updateConfig() {
      var _this2 = this;

      if (!isEqual(this.data, this.WatchData)) {
        //保存配置时转换
        var data = Object.assign({}, this.data);
        delete this.data.preauthenticated_users;
        delete this.data.authenticated_users;
        delete this.data.trustedmac;
        this.data.enabled = this.data.enabled ? '1' : '';
        this.data.webrefresh = this.data.webrefresh ? '1' : '';
        this.data.nowired = this.data.nowired ? '1' : '';

        _updateConfig(this.deviceSn, this.deviceDid, [{
          section: "nodogsplash",
          config: "nodogsplash",
          action: 0,
          index: [0],
          server: 'nodogsplash',
          options: _objectSpread({}, this.data),
          lists: {
            preauthenticated_users: data.preauthenticated_users,
            authenticated_users: data.authenticated_users,
            trustedmac: data.trustedmac
          }
        }]).then(function (res) {
          if (res.data.data.mess === 0) {
            _this2.$message({
              showClose: true,
              message: _this2.$t('lang.ConfigSetting.Successfulconfiguration'),
              type: "success"
            });

            _this2.getConfig();
          } else {
            _this2.$message({
              showClose: true,
              message: _this2.$t('lang.ConfigSetting.Configurationerror'),
              type: "warning"
            });

            return;
          }
        }).catch(function (err) {});
      } else {
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return;
      }
    }
  }
};